export const qParamKeys = {
  qParam1: "[QParam1]",
  qParam2: "[QParam2]",
  qParam3: "[QParam3]",
};

export type QParamKey = keyof typeof qParamKeys;
